<template>
  <div class="fts-tab" v-if="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Tab'
    }
  },
  data:() => ({
    isActive: false
  })
}
</script>